import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import newsPhoto from "../assets/news-hackathon.jpg"; // <-- add your real image here

const NewsAndPublications = () => {
  const news = [
    {
      img: newsPhoto,
      title:
        "2nd Runner Up — Best Presentation Award at Hackathon 2025 on Biodiversity & Climate Change, ZSI Gopalpur"
    }
  ];

  // const publications = [
  //   {
  //     link: "https://www.researchgate.net/publication/393235363_Treatment_of_Synthetic_Coking_Wastewater_Using_a_Sequential_Oxic-Anoxic_Upflow_Packed_Bed_Bioreactor_System",
  //     title:
  //       "Treatment of Synthetic Coking Wastewater Using a Sequential Oxic–Anoxic Upflow Packed Bed Bioreactor System"
  //   },
  //   {
  //     link: "https://www.researchgate.net/publication/362679777_Impact_of_extreme_events_on_the_transformation_of_hydrological_characteristics_of_Asia's_largest_brackish_water_system_Chilika_Lake",
  //     title:
  //       "Impact of extreme events on hydrological transformation of Chilika Lake"
  //   },
  //   {
  //     link: "https://www.researchgate.net/publication/395728415_Adaptive_flight_strategies_in_urban_birds_unraveling_the_intricacies_between_flight_initiation_distance_and_distances_fled",
  //     title:
  //       "Adaptive flight strategies in urban birds: intricacies between flight initiation & distances fled"
  //   },
  //   {
  //     link: "https://www.researchgate.net/publication/394145758_Wild_or_farmed_Natural_water-bodies_not_aquaculture_drive_fish_intake_in_a_top_predator_along_the_Odisha_coast_India",
  //     title:
  //       "Wild or farmed? Natural water-bodies drive fish intake in top predators along Odisha coast"
  //   },
  //   {
  //     link: "https://www.researchgate.net/publication/391937337_Echoes_of_adaptation_House_sparrows'_ecological_response_to_shifting_human_disturbances",
  //     title:
  //       "Echoes of adaptation: House sparrows’ response to shifting human disturbances"
  //   },
  //   {
  //     link: "https://www.researchgate.net/publication/390175526_Habitat-dependent_dietary_pattern_of_white-bellied_sea-eagle_a_cross-regional_meta-analysis",
  //     title:
  //       "Habitat-dependent dietary pattern of white-bellied sea-eagle: a meta-analysis"
  //   },
  //   {
  //     link: "https://www.researchgate.net/publication/352754453_Hydro-geochemical_analysis_based_on_entropy_and_geostatistics_model_for_delineation_of_anthropogenic_ground_water_pollution_for_health_risks_assessment_of_Dhenkanal_district_India",
  //     title:
  //       "Hydro-geochemical analysis for delineating groundwater pollution in Dhenkanal district"
  //   },
  //   {
  //     link: "https://www.researchgate.net/publication/386554209_Urban_Sky_Roosts_The_Unconventional_Adaptation_of_Spot-billed_Pelicans_to_Anthropogenic_Structures",
  //     title:
  //       "Urban Sky Roosts: Adaptation of Spot-billed Pelicans to built structures"
  //   },
  //   {
  //     link: "https://www.researchgate.net/publication/380385304_The_Cognition_of_Geophagy_Mapping_Global_Research_Outputs",
  //     title: "The Cognition of Geophagy: Mapping global research outputs"
  //   },
  //   {
  //     link: "https://www.researchgate.net/publication/376158783_Adaptive_Flight_Strategies_in_Urban_Birds_Unraveling_the_Intricacies_between_Flight_Initiation_Distance_and_Distances_Fled",
  //     title:
  //       "Adaptive Flight Strategies in Urban Birds: Insights into FID and flight distances"
  //   }
  // ];

  return (
    <section className="py-16 bg-gray-900 text-white">
      <style>
        {`
          .no-underline a {
            text-decoration: none !important;
          }
          .no-underline a:hover {
            color: #a3e635; /* lime-400 on hover */
          }
            @keyframes marquee {
            0% {
              transform: translateY(100%);
            }
            100% {
              transform: translateY(-100%);
            }
          }

          .animate-marquee {
            animation: marquee 20s linear infinite;
          }

          /* ⏸ Pause animation on hover */
          .pause-on-hover:hover .animate-marquee {
            animation-play-state: paused;
          }
        `}
        
      </style>

      <div className="w-11/12 md:w-4/5 mx-auto flex flex-col md:flex-row gap-8">
        
        {/* Latest News Section */}
        {/* <div className="md:w-3/5 w-full"> */}
        <div className="w-full">
          <h2 className="text-3xl font-bold text-lime-400 mb-6">LATEST NEWS</h2>

          <Swiper
            modules={[Navigation]}
            navigation={news.length > 1}
            spaceBetween={16}
            loop={false}
            slidesPerView={1} 
          >
            {news.map((item, i) => (
              <SwiperSlide
                key={i}
                className="flex flex-col items-center bg-gray-800 rounded-lg shadow-lg overflow-hidden p-2"
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-50 object-cover rounded"
                />
                <div className="p-3 text-center">
                  <h3 className="text-lg font-semibold text-lime-400">
                    {item.title}
                  </h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Publications */}
        {/* <div className="md:w-2/5 w-full">
          <h2 className="text-3xl font-bold text-lime-400 mb-6">OUR PUBLICATIONS</h2>
          <div className="h-80 overflow-hidden relative no-underline pause-on-hover">
            <ul className="absolute animate-marquee space-y-4">
              {publications.map((pub, i) => (
                <li key={i} className="flex items-start space-x-2">
                  <span className="text-lime-400 text-xl leading-none">•</span>
                  <a
                    href={pub.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-sm hover:text-lime-300 transition"
                  >
                    {pub.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div> */}

      </div>
    </section>
  );
};

export default NewsAndPublications;
